<template>
  <div class="departments">
    <FunctionTitle :title="mainTitle" />
      <CommonFlame :title="subTitle" max-width="1000px">
        <v-container > 
          <div class="table-container mt-4">
            <v-data-table
              locale="ja-JP"
              :headers="headers"
              :items="features"
              :mobile-breakpoint="240"
              hide-default-footer
              disable-filtering
              disable-pagination
              disable-sort
              no-data-text="データがありません。"
            >
            <template v-slot:item="{ item }">
              <tr> 
                <td>{{ item.id }}</td>
                <td>{{ item.name}}</td>
                <td>{{ item.description}}</td>
              </tr>
            </template>
            </v-data-table>
          </div>
        </v-container>
      </CommonFlame> 
  </div>
</template>
<script>
import errorHandling from "../../helper/errorHandling";
import axios from 'axios';
import authenticate from "../../helper/authenticate";
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
  export default {
    components: {
      FunctionTitle,
      CommonFlame,
	  },
    data() {
      return{
        features:[],
        mainTitle: "機能一覧",
        subTitle:"機能情報",
         headers: [
          { text: "機能番号",value: "id", width:"100px"},
          { text: "機能名", value: "name", width:"280px" },
          { text: "機能説明", value: "description", width:"400px" },
			  ],
      }
    },

    mounted(){
      authenticate.authenticateUser();
      const headers = authenticate.setHeader();
      axios
        .get("/erp/v1/features", { headers })
        .then((res) => {
          this.features = res.data.features
        })
        .catch((err) => {
          errorHandling.errorResponse(err);
        });
    },
  }

</script>